"use client";

import { IconLoader2, IconUser } from "@tabler/icons-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";
import React from "react";
import { useUserContext } from "../../../providers/UserProvider";
import { RAILS_ROUTES } from "../helpers/routes";

export const MobileSignupAvatar = () => {
  const { currentUserAll } = useUserContext();
  const user = currentUserAll?.data?.me;
  const isLoggedIn = !!user;

  return (
    <a
      href={isLoggedIn ? RAILS_ROUTES.DASHBOARD : RAILS_ROUTES.SIGNUP_GENERIC}
      className="relative flex text-utility-gray-400 hover:text-alpha-white-100 py-md px-xs"
      onClick={
        !isLoggedIn
          ? () => {
              window.posthog?.capture("web_onboarding", {
                operation_name: "nav_mobile_avatar_click",
                application: "rails",
              });
            }
          : undefined
      }
    >
      {isLoggedIn ? (
        <Avatar className="size-4xl">
          <AvatarImage
            src={user.avatarUrl ?? undefined}
            alt={user.displayName ?? "Avatar"}
          />
          <AvatarFallback className="text-quaternary">
            <IconLoader2 className="size-3xl animate-spin" />
          </AvatarFallback>
        </Avatar>
      ) : (
        <IconUser width={32} className="shrink-0" />
      )}
    </a>
  );
};
